import { GET_APP_NAME, BUNDLE_APP_NAME } from '../../app_constant';

/**
 * Base PostHog super-properties for the web app. Shared by the
 * AnalyticsProvider mount effect and the sign-out path in AuthProvider:
 * posthog-js `reset()` clears persistence, super-properties included, so a
 * real sign-out has to re-register them for the new anonymous identity.
 *
 * `register()` is local-only (no event emitted).
 */
export function registerBaseSuperProps(posthog, selectedCertificate) {
  if (!posthog) return;
  const cert = selectedCertificate || localStorage.getItem('selectedCertificate') || 'cisa';
  posthog.register({
    app_name: BUNDLE_APP_NAME,
    exam_name: GET_APP_NAME(cert),
    platform: 'web',
    source_environment: process.env.NODE_ENV || 'production',
    app_version: process.env.REACT_APP_APP_VERSION || 'dev',
    build_commit: process.env.REACT_APP_BUILD_COMMIT || 'unknown',
  });
}
